<template>
  <div class="flex items-center lg:mb-3">
    <component
      :is="mainContent ? 'h2' : 'h1'"
      class="flex grow justify-between"
    >
      <div class="flex flex-col">
        <div class="text-8pt font-bold">
          <span>{{ legalText.name }} &nbsp;</span>
          <button
            class="md:hidden landscape:hidden"
            @click="infoModalOpen = true"
          >
            <span class="sr-only">info</span>
            <i-material-symbols-info-outline-rounded class="size-3.5" />
          </button>
        </div>
        <div
          class="flex space-x-2 text-6pt font-normal mobile-landscape:hidden max-sm:hidden"
        >
          <span>
            {{ legalText.short_name || legalText.full_name }}
          </span>
          <button @click="infoModalOpen = true">
            <span class="sr-only">info</span>
            <InfoIcon class="size-2.5" />
          </button>
        </div>
      </div>
      <div>
        <button
          v-tooltip="fullView ? t('single_view') : t('full_view')"
          class="rounded-full p-2 transition hover:bg-gray-200"
          @click="fullView = !fullView"
        >
          <span class="sr-only">{{
            fullView ? t("full_view") : t("single_view")
          }}</span>
          <i-material-symbols-light-multiple-stop
            class="size-6 transition-transform"
            :class="{ 'rotate-90': fullView }"
          />
        </button>
      </div>
    </component>
    <LexmeaModal v-model="infoModalOpen" :noPaddingY="true">
      <template #title>
        {{ legalText.short_name || legalText.name }}
      </template>
      <template #default>
        <div class="flex flex-col gap-4 pt-4 text-justify">
          <div>{{ t("long_title", { full_name: legalText.full_name }) }}</div>
          <div
            v-if="
              legalText.legal_text_revisions &&
              legalText.legal_text_revisions.length > 0
            "
          >
            <div class="font-bold">{{ t("revision") }}</div>
            <ul class="list-none">
              <li
                v-for="revision in legalText.legal_text_revisions"
                :key="revision.id"
              >
                {{ revision.content }}
              </li>
            </ul>
          </div>
        </div>
      </template>
    </LexmeaModal>
  </div>
</template>

<script lang="ts" setup>
import InfoIcon from "~/assets/info.svg";
import type { ILegalText } from "~/models/ILegalText";

type Props = {
  mainContent: boolean;
  legalText: ILegalText;
};

defineProps<Props>();

const infoModalOpen = ref(false);

const { t } = useI18n({ useScope: "local" });

const fullView = defineModel<boolean>("fullView", { required: true });
</script>

<i18n>
{
  "de": {
    "full_view": "Zur Gesamtansicht",
    "single_view": "Zur Einzelansicht",
    "revision": "Stand",
    "long_title": "Langtitel: {full_name}"
  },
  "en": {
    "full_view": "To full view",
    "single_view": "To single view",
    "revision": "Revision",
    "long_title": "Full title: {full_name}"
  }
}
</i18n>
